module.exports = __webpack_public_path__ + "static/media/broszura_IFA_1_B.fdb62121.png";